<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'roles')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('delete', 'roles')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no roles to display") }}
      </h6>
    </div>
    <roles-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../../common/mixins/list'
import RolesEditModal from '../edit/RolesEditModal'

export default {
  name: 'RolesList',
  components: { RolesEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'roles',
    }
  },
}
</script>

<style scoped>

</style>
